module.exports = __webpack_public_path__ + "static/media/session.4b3ed06a.svg";